// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Signature_imageContainer__1ru7a","image":"Signature_image__DYpJX"};